import './TrendingGames.css';
import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslations } from '../../../../hooks/use-translations.hook';
import { SearchGameItem } from '../SearchGameItem';
import { useFilteredPrioritizedGames } from '../../../../hooks/use-filtered-prioritized-games.hook';
import { useNeoCmsFeatureRelatedGamesHook } from '../../../../hooks/use-neo-cms-feature-related-games.hook';
import { NeoCmsGameCategoryFeatureNamesEnum } from '../../../../enums/neo-cms-game-category-feature-names.enum';

export const TrendingGames = () => {
    const { t } = useTranslations();
    const { isNeoCmsIntegrationEnabled } = useSelector((state) => state.app);
    const { gamesById } = useSelector((state) => (state.casino));
    const [gamesToShow, setGamesToShow] = useState([]);
    let { presentPrioritizedGamesOnBrand } = useFilteredPrioritizedGames();
    const featureName = NeoCmsGameCategoryFeatureNamesEnum.SEARCH_TRENDING;
    const { featureRelatedGames } = useNeoCmsFeatureRelatedGamesHook(featureName);

    const trendingGames = useMemo(() => {
        return isNeoCmsIntegrationEnabled
            ? featureRelatedGames.map(game => game.id)
            : presentPrioritizedGamesOnBrand;
    }, [isNeoCmsIntegrationEnabled, featureRelatedGames, presentPrioritizedGamesOnBrand]);

    useEffect(() => {
        if (trendingGames.length > 0) {
            setGamesToShow(trendingGames.slice(0, 6));
        }
    }, [trendingGames]);

    return (
        <div className="asg-search-results-trending">
            <div className="asg-search-results-trending__title asg-search-results-title">{t('trending')}</div>
            <div className="asg-search-results-trending__list">
                {gamesToShow.map((gameId) => (<SearchGameItem
                    key={gameId}
                    game={gamesById[gameId]}
                />))}
            </div>
        </div>
    );
};
